import React from 'react';
import { IconProps } from '../IconProps';


export const De: React.FC<IconProps> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480" width={props.width} height={props.height} version="1" y="0" x="0" className={props.className}>
            <g id="flag" fillRule="evenodd" strokeWidth="1pt" transform="matrix(.60207 0 0 .75259 0 -.000028157)">
                <rect id="rect171" height="212.6" width="1063" y="425.2" x="0" fill="#ffe600"/>
                <rect id="rect256" height="212.6" width="1063" y="0.000038" x="0"/>
                <rect id="rect255" height="212.6" width="1063" y="212.6" x="0" fill="#f00"/>
            </g>
        </svg>)
};
